import React from 'react';
import InternationalInvestmentsView from "./InternationalInvestmentsView"
function InternationalInvestments(props) {
    return (
        <InternationalInvestmentsView/>
    );
}

export default InternationalInvestments;
